export enum ESubscriptionDataTypes {
  Guid = 0,
  String = 1,
  Boolean = 2,
  EMail = 4,
  Date = 5,
  Integer = 6,
  TariffOrigin = 7,
  TariffDestination = 8,
  TariffVia = 9,
  TariffZoneOrigin = 10,
  TariffZoneDestination = 11,
  SelectionField = 12,
  Label = 13,
  Image = 17,
  IndividualObject = 18,
  Price = 19,
  TariffViaImage = 20,
  Address = 21,
  PriceLevel = 22,
}
